import { cn } from '@/lib/utils'
import MarkerText from './MarkerText'
import AssignmentReminderTimeBadge from './AssignmentReminderTimeBadge'

type Props = {
  text?: string
  color?: string
  offsetSeconds?: number
  cascadeSeconds?: number
}

const AssignmentScopeReminderText = ({
  text,
  color,
  offsetSeconds,
  cascadeSeconds,
}: Props) => {
  if (!text) return null
  return (
    <span
      className={cn(
        'ml-2 inline-flex items-center gap-1 flex-wrap align-middle',
        !color && 'text-info-foreground',
      )}
      style={color ? { color } : undefined}
    >
      <span className='inline-flex items-center gap-0.5'>
        &quot;
        <MarkerText text={text} />
        &quot;
      </span>
      <AssignmentReminderTimeBadge
        offsetSeconds={offsetSeconds}
        cascadeSeconds={cascadeSeconds}
      />
    </span>
  )
}

export default AssignmentScopeReminderText
